import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { AdmissionFrontApi } from '../../../api/admission-front/admission-front.api';
import { alertError, alertSuccess } from '../../../components/alert/swal';
import ContainerButton from '../../../components/button/ContainerButton';
import { Box, Checkbox, FormControl, FormControlLabel, InputBase, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import StateComponents from '../../../components/state-component/StateComponents';
import { EXAMS, exams_enum } from '../manage-exams/manage-exams-detail';
import { useTranslation } from 'react-i18next';
import { routeName } from '../../../routes/routeName';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import InputTextField from '../../../components/input/inputTextField';

export default function FormExamination() {
    const { id, id_period_examination_student } = useParams()
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [form, setForm] = useState<any>();
    const [answer, setAnswer] = useState<any[]>([])

    const getDetail = async () => {
        // dispatch(setLoading());

        await AdmissionFrontApi.findExam(id, id_period_examination_student).then((res) => {
            if (res.status < 300) {
                setForm(res.data.data)
                setAnswer(res.data.data?.examination_details?.map((item: any) => {
                    return {
                        ...item,
                        examination_answers: item?.examination_answers?.map((x: any) => {
                            return {
                                ...x,
                                examination_answer_true: x?.student_result?.examination_student_answer === '1',
                                examination_answer: x?.student_result?.examination_answer,
                                examination_title: x?.examination_answer,

                            }
                        })
                    }
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            // dispatch(unsetLoading());
        })
    }
    useEffect(() => {
        getDetail()
    }, [])

    const handleSubmit = async (type?: any) => {
        const body = {
            // ...form,
            examination_details: answer?.map((item: any) => {
                return {
                    id_examination_detail: item?.id_examination_detail,
                    student_point: item?.student_point,
                    examination_answers: item?.examination_answers?.map((x: any) => {
                        return {
                            id_examination_answer: x?.id_examination_answer,
                            examination_answer: x?.examination_answer,
                            student_result: {
                                examination_student_answer: x?.examination_answer_true ? 1 : item?.examination_type === EXAMS.ANSWER ? 1 : 0,
                                id_period_examination_student_result: x?.student_result?.id_period_examination_student_result
                            }
                        }
                    })
                }
            })
        }

        await AdmissionFrontApi.patchExam(id, id_period_examination_student, body)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("บันทึก"), t("บันทึก เรียบร้อย"));
                    if (type === 'SAVE_DRAFT') {
                        getDetail()
                    } else {
                        navigate(routeName.admission.AdmissionDetail?.replace(':id', `${id}`))
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("บันทึก"), err?.response?.data?.message || "Error");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    console.log(answer);
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("Take the Exam")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("IBSC Online Admission"),
                                disabled_match: true,
                                pathName: routeName.admission.HistoryOnlineAdmission
                            },

                            {
                                key: "complaintSubmit",
                                name: t("Application Information"),
                                pathName: routeName.admission.AdmissionDetail
                            },
                        ]}
                    />
                }

                content={
                    <>
                        <InputTextField heading={'Explanation'} value={form?.examination_desc} multiline inputHeight={"auto"} minRow={6} disabled />
                        {
                            answer.map((item: any, index: number) => {
                                return (
                                    <article key={index + 1} className='col-span-12 mt-6'>
                                        <Box
                                            sx={{
                                                boxShadow: '0px 0px 2px 2px rgba(0, 0, 0, 0.12)',
                                                borderRadius: '10px',
                                                borderBottom: '8px solid #0075CB'
                                            }}
                                        >
                                            <Box sx={{ padding: "20px" }}>
                                                <StateComponents
                                                    otherProps={{ spacing: 2 }}
                                                    typeProps={
                                                        [
                                                            {
                                                                seq: 1,
                                                                type: "SELECT",
                                                                gridProps: {
                                                                    xs: 12,
                                                                    md: 4
                                                                },
                                                                fieldProps: {
                                                                    disabled: true,
                                                                    labelId: "select_detail_type_" + index,
                                                                    placeholder: t("ระบุรูปแบบ"),
                                                                    heading: t("รูปแบบ"),
                                                                    options: exams_enum,
                                                                    selectId: "select_detail_type_" + index,
                                                                    onChange: (e) => {
                                                                        setAnswer((prevData) =>
                                                                            prevData.map((p: any, i: number) =>
                                                                                index === i ? {
                                                                                    ...p, examination_type: e.target.value,
                                                                                    examination_answers: e.target.value === EXAMS.ANSWER ? [
                                                                                        {
                                                                                            examination_answer: '',
                                                                                            examination_answer_true: true
                                                                                        }
                                                                                    ] : [{
                                                                                        examination_answer: 'ตัวเลือก', // i18n-ignore
                                                                                        examination_answer_true: true
                                                                                    }]
                                                                                } : p
                                                                            )
                                                                        );
                                                                    },
                                                                    value: item?.examination_type || ''
                                                                }
                                                            },
                                                            {
                                                                seq: 2,
                                                                type: "TEXT_FIELD",
                                                                gridProps: {
                                                                    xs: 12,
                                                                    md: 12
                                                                },
                                                                fieldProps: {
                                                                    multiline: true,
                                                                    row: 3,
                                                                    maxRows: 5,
                                                                    inputHeight: "auto",
                                                                    disablePaddingMultiline: true,
                                                                    disabled: true,
                                                                    placeholder: t("ระบุคำถาม"),
                                                                    heading: t("คำถาม"),
                                                                    onChange: (e) => {
                                                                        setAnswer((prevData) =>
                                                                            prevData.map((p: any, i: number) =>
                                                                                index === i ? { ...p, examination_question: e.target.value } : p
                                                                            )
                                                                        );
                                                                    },
                                                                    value: item?.examination_question || ''
                                                                }
                                                            },
                                                        ]
                                                    }
                                                />
                                                {
                                                    item?.examination_type === EXAMS.SINGLE_CHOICE &&
                                                    <Box sx={{ marginTop: 2, width: '100%' }}>

                                                        <FormControl fullWidth>
                                                            <RadioGroup>
                                                                {
                                                                    item.examination_answers && item.examination_answers.length > 0 ?
                                                                        <>

                                                                            {item?.examination_answers?.sort((a: any, b: any) => a?.id_examination_answer - b?.id_examination_answer)?.map((choice: any, choiceindex: any) => (
                                                                                <FormControlLabel
                                                                                    slotProps={{ typography: { "width": "100%" } }}
                                                                                    key={choiceindex + 1}
                                                                                    id={'choice' + choiceindex}
                                                                                    control={<Radio />}
                                                                                    checked={choice?.examination_answer_true || ''}
                                                                                    onChange={(e: any) => {
                                                                                        const newValue = e.target.checked;
                                                                                        setAnswer((prevData) =>
                                                                                            prevData.map((q, qIndex) =>
                                                                                                qIndex === index
                                                                                                    ? {
                                                                                                        ...q,
                                                                                                        examination_answers: q.examination_answers.map(
                                                                                                            (ans: any, aIndex: number) =>
                                                                                                                aIndex === choiceindex
                                                                                                                    ? { ...ans, examination_answer_true: newValue, examination_answer: choice?.examination_answer }
                                                                                                                    : { ...ans, examination_answer_true: false }
                                                                                                        ),
                                                                                                    }
                                                                                                    : q
                                                                                            )
                                                                                        );
                                                                                    }}
                                                                                    label={choice?.examination_title}
                                                                                />
                                                                            ))}
                                                                        </>
                                                                        :
                                                                        <></>
                                                                }

                                                            </RadioGroup>
                                                        </FormControl>

                                                    </Box>
                                                }
                                                {
                                                    item?.examination_type === EXAMS.MULTIPLE_CHOICE &&
                                                    <Box sx={{ marginTop: 2, width: '100%' }}>

                                                        <FormControl fullWidth>
                                                            {
                                                                item?.examination_answers && item?.examination_answers?.length > 0 ?
                                                                    <>

                                                                        {item.examination_answers?.sort((a: any, b: any) => a?.id_examination_answer - b?.id_examination_answer).map((choice: any, choiceindex: any) => (
                                                                            <FormControlLabel
                                                                                slotProps={{ typography: { "width": "100%" } }}
                                                                                key={choiceindex + 1}
                                                                                id={'choice' + choiceindex}
                                                                                // value={choice.examination_answer + '' + choiceindex}
                                                                                control={<Checkbox />}
                                                                                checked={choice?.examination_answer_true}
                                                                                onChange={(e: any) => {
                                                                                    const newValue = e.target.checked;
                                                                                    setAnswer((prevData) =>
                                                                                        prevData.map((q, qIndex) =>
                                                                                            qIndex === index
                                                                                                ? {
                                                                                                    ...q,
                                                                                                    examination_answers: q.examination_answers.map(
                                                                                                        (ans: any, aIndex: number) =>
                                                                                                            aIndex === choiceindex
                                                                                                                ? { ...ans, examination_answer_true: newValue, examination_answer: choice?.examination_answer }
                                                                                                                : ans
                                                                                                    ),
                                                                                                }
                                                                                                : q
                                                                                        )
                                                                                    );
                                                                                }}
                                                                                label={choice?.examination_title}
                                                                            />
                                                                        ))}
                                                                    </> :
                                                                    <></>

                                                            }
                                                        </FormControl>

                                                    </Box>}
                                                {item?.examination_type === EXAMS.ANSWER &&
                                                    <Box sx={{ marginTop: 2, width: '100%' }}>
                                                        {
                                                            item.examination_answers && item.examination_answers.length > 0 ?
                                                                <>

                                                                    {item?.examination_answers?.map((choice: any, choiceindex: any) => (
                                                                        <StateComponents
                                                                            otherProps={{ spacing: 2 }}
                                                                            typeProps={
                                                                                [

                                                                                    {
                                                                                        seq: 1,
                                                                                        type: "TEXT_FIELD",
                                                                                        gridProps: {
                                                                                            xs: 12,
                                                                                            md: 12
                                                                                        },
                                                                                        fieldProps: {
                                                                                            multiline: true,
                                                                                            row: 3,
                                                                                            maxRows: 5,
                                                                                            inputHeight: "auto",
                                                                                            disablePaddingMultiline: true,
                                                                                            placeholder: t("ระบุคำตอบ"),
                                                                                            heading: t("คำตอบ"),
                                                                                            onChange: (e) => {
                                                                                                const newValue = e.target.value;
                                                                                                setAnswer((prevData) =>
                                                                                                    prevData.map((q, qIndex) =>
                                                                                                        qIndex === index
                                                                                                            ? {
                                                                                                                ...q,
                                                                                                                examination_answers: q.examination_answers.map(
                                                                                                                    (ans: any, aIndex: number) =>
                                                                                                                        aIndex === choiceindex
                                                                                                                            ? { ...ans, examination_answer: newValue }
                                                                                                                            : ans
                                                                                                                ),
                                                                                                            }
                                                                                                            : q
                                                                                                    )
                                                                                                );
                                                                                            },
                                                                                            value: choice?.examination_answer || ''
                                                                                        }
                                                                                    },
                                                                                ]
                                                                            }
                                                                        />))}</> : <></>}
                                                    </Box>
                                                }

                                            </Box>
                                        </Box>

                                    </article>
                                )

                            })}
                        < ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { },
                                    },
                                    key: "CANCEL",
                                    label: "Cancel",
                                    type: "CANCEL"
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit('SAVE_DRAFT')
                                        }
                                    },
                                    key: "SAVE_DRAFT",
                                    label: "Save Draft",
                                    type: "SAVE_DRAFT"
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    key: "NONE",
                                    label: "confirm",
                                    type: 'NONE'
                                },

                            ]}
                        /></>}
            />
        </div>
    )
}
